import { Moon, Sun } from 'lucide-react';
import { useThemeStore } from '../../stores/theme';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

/**
 * Light/dark switch. Self-contained (it brings its own TooltipProvider) so any
 * shell can drop it in — the platform topbar, but also the guest chrome, where
 * there is no surrounding provider.
 */
export function ThemeToggle({ className }: { className?: string }) {
	const theme = useThemeStore((s) => s.theme);
	const toggleTheme = useThemeStore((s) => s.toggleTheme);
	const nextIsLight = theme === 'dark';
	const label = nextIsLight ? 'Switch to light theme' : 'Switch to dark theme';

	return (
		<TooltipProvider delay={300}>
			<Tooltip>
				<TooltipTrigger
					onClick={toggleTheme}
					aria-label={label}
					className={
						className ??
						'flex size-7 cursor-pointer items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-surface-hover hover:text-foreground'
					}
				>
					{nextIsLight ? <Sun size={16} /> : <Moon size={16} />}
				</TooltipTrigger>
				<TooltipContent>{label}</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
